




































































import Vue, { PropType } from 'vue'
import UiIcon from '../../UiIcon'
import UiImage from '../../UiImage'
import { ProductItem } from '../UiSeriesList.types'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default Vue.extend({
  name: 'UiSeriesCompareList',
  components: {
    UiIcon,
    UiImage
  },
  inheritAttrs: false,
  props: {
    products: {
      type: Array as PropType<ProductItem[]>,
      default: () => []
    },
    productsCounter: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    i18n: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    show (nextVal: boolean) {
      nextVal ? disableBodyScroll(this.$refs.products as HTMLElement) : enableBodyScroll(this.$refs.products as HTMLElement)
    }
  },
  beforeDestroy () {
    clearAllBodyScrollLocks()
  },
  methods: {
    toggleProductHandler (product: ProductItem): void {
      product.isSelected ? this.$emit('remove', product.content.ean) : this.$emit('add', product.content.ean)
    }
  }
})
